export default [
  {
    path: '/',
    name: '首页',
    component: () => import('../views/index')
  },
  {
    path: '/login',
    name: '登录',
    component: () => import('../views/login')
  },
  {
    path: '/register',
    name: '注册',
    component: () => import('../views/register')
  },
  {
    path: '/user/cart',
    name: '购物车',
    component: () => import('../views/user/cart')
  },
  {
    path: '/user/order',
    name: '订单',
    component: () => import('../views/user/order')
  },
  {
    path: '/user/order-create',
    name: '创建订单',
    component: () => import('../views/user/order-create')
  }
]